import { ConciergeItemPage } from '@/lib/pages/concierge/ConciergeItemPage';
import {
  getConciergeItemStaticPaths,
  getConciergeItemStaticProps,
} from '@/lib/pages/concierge/get-item-static-props';

export default ConciergeItemPage;

export const getStaticPaths = getConciergeItemStaticPaths('shows');
export const getStaticProps = getConciergeItemStaticProps('shows');
